import { render } from "./App.vue?vue&type=template&id=4cc7e168"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4cc7e168&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__